import React from "react";
export const RankingContext = React.createContext();
